/**
 * Symbol Picker Button Component
 * Button to open the symbol picker modal
 */

import React, { useState } from 'react'
import { EditorView } from '@codemirror/view'
import { SparklesIcon } from '@heroicons/react/24/outline'
import clsx from 'clsx'
import SymbolPickerModal from './SymbolPickerModal'

interface SymbolPickerButtonProps {
  view: EditorView | null
  theme?: 'light' | 'dark'
}

const SymbolPickerButton: React.FC<SymbolPickerButtonProps> = ({ view, theme = 'light' }) => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const buttonClass = clsx(
    'p-1.5 rounded transition-colors',
    theme === 'dark'
      ? 'text-gray-300 hover:bg-gray-700 hover:text-white'
      : 'text-gray-800 hover:bg-gray-100 hover:text-gray-900',
    'disabled:opacity-50 disabled:cursor-not-allowed'
  )

  return (
    <>
      <button
        type="button"
        onClick={() => setIsModalOpen(true)}
        disabled={!view}
        className={buttonClass}
        title="Symbol picker - Browse and insert LaTeX math symbols (Greek letters, operators, arrows, etc.)"
        aria-label="Symbol picker"
      >
        <SparklesIcon className="w-4 h-4" />
      </button>

      <SymbolPickerModal
        view={view}
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        theme={theme}
      />
    </>
  )
}

export default SymbolPickerButton

